<template>
  <router-view />
  <!-- 嵌套子网站 -->
  <div v-show="false">
    <iframe
      ref="ringdataRef"
      src="https://www.ringdata.com/user-center/free/index.html"
    ></iframe>
  </div>
</template>
<script>
import store from "@/store";
import VueCookies from "vue-cookies";
import {
  ref,
  reactive,
  toRefs,
  watch,
  provide,
  nextTick,
  onMounted,
} from "vue";

export default {
  setup(props, context) {
    const ringdataRef = ref(null);

    const freeLogin = () => {
      let params = {
        type: "sa",
        params: {
          tk: {
            value: VueCookies.get("tokenWeb"),
            expires: 24 * 60 * 60,
          },
          ui: {
            value: VueCookies.get("userInfo"),
            expires: 24 * 60 * 60,
          },
          rtk: {
            value: VueCookies.get("tokenWebRefresh"),
            expires: 47 * 60 * 60,
          },
        },
      };
      ringdataRef.value &&
        ringdataRef.value.contentWindow.postMessage(
          params,
          "https://www.ringdata.com"
        );
    };
    const clearCookie = () => {
      let params = {
        type: "rm",
        params: {},
      };
      ringdataRef.value &&
        ringdataRef.value.contentWindow.postMessage(
          params,
          "https://www.ringdata.com"
        );
    };
    watch(
      () => store.state.isLogin,
      (newVal) => {
        if (newVal) {
          freeLogin();
        } else {
          clearCookie();
        }
      },
      { immediate: true, deep: true }
    );
    return {
      ringdataRef,
    };
  },
};
</script>

<style>
#app {
  font-size: 14px;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #383838;
}
</style>
